import { getApiBaseUrl, getTenantSlugFromHostname } from './api';

function buildHeaders() {
  const headers = {
    'Content-Type': 'application/json',
  };

  const tenantSlug = getTenantSlugFromHostname();
  if (tenantSlug) {
    headers['X-Tenant-Slug'] = tenantSlug;
  }

  return headers;
}

async function parseResponse(response) {
  const contentType = response.headers.get('content-type') || '';
  const payload = contentType.includes('application/json')
    ? await response.json().catch(() => ({}))
    : {};

  if (!response.ok) {
    const message = payload?.error || `Request failed (${response.status})`;
    throw new Error(message);
  }

  return payload;
}

export async function registerAuthenticatedProfile({ visitorId = null } = {}) {
  const response = await fetch(`${getApiBaseUrl()}/api/auth/profile/register`, {
    method: 'POST',
    headers: buildHeaders(),
    credentials: 'include',
    body: JSON.stringify({ visitorId }),
  });

  return parseResponse(response);
}

export async function fetchOwnProfile({ optional = false } = {}) {
  const endpoint = optional ? '/api/auth/profile?optional=true' : '/api/auth/profile';
  const response = await fetch(`${getApiBaseUrl()}${endpoint}`, {
    method: 'GET',
    headers: buildHeaders(),
    credentials: 'include',
  });

  return parseResponse(response);
}

export async function updateOwnProfileDisplayName(profileUpdate) {
  const bodyPayload = typeof profileUpdate === 'string'
    ? { displayName: profileUpdate }
    : {
      displayName: profileUpdate?.displayName,
      name: profileUpdate?.name,
      avatar: profileUpdate?.avatar,
    };

  const response = await fetch(`${getApiBaseUrl()}/api/auth/profile`, {
    method: 'PATCH',
    headers: buildHeaders(),
    credentials: 'include',
    body: JSON.stringify(bodyPayload),
  });

  return parseResponse(response);
}

export async function resolveLightweightProfile({
  email = '',
  name = '',
  phone = '',
  visitorId = null,
  source = null,
  smsMarketingConsent = false,
  smsConsentRequestId = null,
  smsConsentVersion = null,
  webOrigin = null,
} = {}) {
  const response = await fetch(`${getApiBaseUrl()}/api/auth/profile/resolve`, {
    method: 'POST',
    headers: buildHeaders(),
    credentials: 'include',
    body: JSON.stringify({ email, name, phone, visitorId, source, smsMarketingConsent, smsConsentRequestId, smsConsentVersion, webOrigin }),
  });

  return parseResponse(response);
}
